import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
    //mode: 'history',
    routes: [{
            path: '/',
            name: 'recommend',
            component: () =>
                import ('@/view/recommend/recommend')
        },
        {
            path: "/advisory",
            name: 'advisory',
            component: () =>
                import ("@/view/advisory/advisory")
        },
        {
            path: '/regulation',
            name: 'regulation',
            component: () =>
                import ("@/view/regulation/regulation")
        },
        {
            path: '/education',
            name: 'education',
            component: () =>
                import ("@/view/education/education")
        },
        {
            path: '/management',
            name: 'management',
            component: () =>
                import ("@/view/management/management")
        },
        {
            path: '/case',
            name: 'case',
            component: () =>
                import ("@/view/case/case")
        },
        {
            path: '/newdetails',
            name: 'newdetails',
            component: () =>
                import ("@/view/details/newdetails")
        },
        {
            path: '/search',
            name: 'search',
            component: () =>
                import ("@/view/search/search")
        },
        {
            path: '/lowversion',
            name: 'lowversion',
            component: () =>
                import ("@/view/lowversion/lowversion")
        },
        {
            path:'/video',
            name:'video',
            component: () => import('@/view/video/video')
        },
        {
             path:'videoDetail',
             name:'videoDetail',
             component: () => import('@/view/videoDetail/videoDetail')
        }
    ],
    linkExactActiveClass: 'active',
})


// WEBPACK FOOTER //
// ./src/router/index.js